function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import Icon from '../icon';
import classNames from 'classnames';
export default function InputIcon(props) {
  var _classNames;

  var suffixIcon = props.suffixIcon,
      prefixCls = props.prefixCls;
  return suffixIcon && (React.isValidElement(suffixIcon) ? React.cloneElement(suffixIcon, {
    className: classNames((_classNames = {}, _defineProperty(_classNames, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames, "".concat(prefixCls, "-picker-icon"), true), _classNames))
  }) : React.createElement("span", {
    className: "".concat(prefixCls, "-picker-icon")
  }, suffixIcon)) || React.createElement(Icon, {
    type: "calendar",
    className: "".concat(prefixCls, "-picker-icon")
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/date-picker/InputIcon.js
// module id = 376
// module chunks = 14